import * as yup from 'yup';

export const rangesSchema = yup.object({
  includeNonAid: yup.boolean(),
  includeNonAgi: yup.boolean(),
  ranges: yup
    .array()
    .of(
      yup.object({
        from: yup
          .number()
          .nullable()
          .test(
            'not-both-null',
            'From and To cannot both be empty',
            function (from) {
              const { to } = this.parent;

              return from != null || to != null;
            }
          ),
        to: yup
          .number()
          .nullable()
          .test(
            'greater-than-or-equal-from',
            'Must be greater than or equal to From',
            function (to) {
              const { from } = this.parent;

              return from == null || to == null || to >= from;
            }
          ),
      })
    )
    .test('intermediate-to-required', '', function (ranges) {
      if (!ranges) return true;

      for (let i = 0; i < ranges.length - 1; i++) {
        if (ranges[i].to == null) {
          return this.createError({
            path: `${this.path}[${i}].to`,
            message: 'Required',
          });
        }
      }

      return true;
    })
    .test('non-first-from-required', '', function (ranges) {
      if (!ranges) return true;

      for (let i = 1; i < ranges.length; i++) {
        if (ranges[i].from == null) {
          return this.createError({
            path: `${this.path}[${i}].from`,
            message: 'Required',
          });
        }
      }

      return true;
    })
    .test('sequential-ranges', '', function (ranges) {
      if (!ranges) return true;

      for (let i = 1; i < ranges.length; i++) {
        const prev = ranges[i - 1];
        const curr = ranges[i];

        if (prev.to != null && curr.from != null && curr.from <= prev.to) {
          return this.createError({
            path: `${this.path}[${i}].from`,
            message: `Must be greater than ${prev.to}`,
          });
        }
      }

      return true;
    }),
});
